import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FocusLayout, FocusLayoutContainer, TrackLoop, } from '@livekit/components-react';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'react';
import { ParticipantGrid, ParticipantTile, ScrollArea, Stack, cn, } from '@marvelapp/ballpark-components';
function useIsAtEnd(scrollRef) {
    const [isAtEnd, setIsAtEnd] = useState(false);
    useEffect(() => {
        const element = scrollRef.current;
        if (!element)
            return;
        const checkIfAtEnd = () => {
            const { scrollHeight, scrollTop, clientHeight } = element;
            // Consider it at the end if we're within 1px of the bottom
            const atEnd = Math.abs(scrollHeight - scrollTop - clientHeight) <= 1;
            setIsAtEnd(atEnd);
        };
        // Check initial position
        checkIfAtEnd();
        // Add scroll listener
        element.addEventListener('scroll', checkIfAtEnd, { passive: true });
        // Add resize observer to recheck when content size changes
        const resizeObserver = new ResizeObserver(checkIfAtEnd);
        resizeObserver.observe(element);
        return () => {
            element.removeEventListener('scroll', checkIfAtEnd);
            resizeObserver.disconnect();
        };
    }, [scrollRef]);
    return isAtEnd;
}
const Screenshare = observer(function Screenshare({ children, participantTracks, screenTracks, }) {
    const viewportRef = useRef(null);
    const isAtEnd = useIsAtEnd(viewportRef);
    // 100vh - controls bar (32px) + top and bottom padding (8px*2) + 8px gap between the video and controls
    return (_jsxs(FocusLayoutContainer, { className: "!flex h-[calc(100vh_-_56px)] !gap-2", children: [children, _jsx(FocusLayout, { trackRef: screenTracks[0], className: "w-full flex-1 bg-gray-800 [&>video]:!bg-gray-800", children: _jsx(ParticipantTile, { withQualityTooltip: true }) }), _jsxs(ScrollArea.Root, { className: "lk-speakers-row-container w-36", "data-scroll-position": isAtEnd ? 'end' : '', children: [_jsx(ScrollArea.Viewport, { ref: viewportRef, children: _jsx(Stack, { gap: "2", className: "lk-speakers-row", children: _jsx(TrackLoop, { tracks: participantTracks, children: _jsx(ParticipantTile, { withQualityTooltip: true }) }) }) }), _jsx(ScrollArea.Scrollbar, { orientation: "vertical", className: cn('p-1') })] })] }));
});
const SpeakersOnly = observer(function SpeakersOnly({ children, participantTracks, }) {
    return (_jsxs(Stack, { className: "!flex h-[calc(100vh_-_56px)] items-center !gap-2", children: [children, _jsx(ParticipantGrid, { tracks: participantTracks })] }));
});
export const LiveRoomLayout = {
    Screenshare,
    SpeakersOnly,
};
